import { databasePasswordAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { mysqlConnectionFields, mysqlConnectionString } from "./shared";

export const mysql = defineConnector({
  identifier: "mysql",
  name: "MySQL",
  tagLine: "Relational database",
  keywords: "mariadb relational rdbms database",
  logo,
  tags: ["data"],
  protocol: "mysql",
  connectionTest: {
    protocol: "mysql",
    connectionString: mysqlConnectionString,
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: (app) => databasePasswordAuth(app.secret.password),
  steps: [
    {
      title: "Enter your MySQL connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "MySQL",
          target: { kind: "connectedApp", field: "name" },
        },
        ...mysqlConnectionFields,
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "select",
          label: "TLS",
          required: true,
          defaultValue: "false",
          target: { kind: "configuration", field: "tls" },
          options: [
            { value: "false", label: "Disabled" },
            { value: "true", label: "Enabled" },
          ],
        },
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Upload a PEM CA certificate for private or self-signed MySQL servers.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
          visibleWhen: {
            target: { kind: "configuration", field: "tls" },
            value: "true",
          },
        },
      ],
    },
  ],
  publicEnvVars: (configuration) => ({
    MYSQL_URL: mysqlConnectionString(configuration),
  }),
  usageHint: () => "Use process.env.MYSQL_URL as the MySQL connection string.",
});
